module.exports = __webpack_public_path__ + "img/bi_sub2.82b5e28d.jpg";